<template>
    <div id="yacurier-form" class="yacurier-form">
        <SmallForm :store="store" :Api="Api"/>
        <FullForm :store="store" :Api="Api" v-if="store.full"/>

    </div>
</template>

<script>
    import SmallForm from './components/blocks/SmallForm/Index.vue';
    import FullForm from './components/blocks/FullForm/Index.vue';
    import axios from 'axios';
    import './styles/fonts.scss';

    const Api = {
        baseUrl: "//remote.api.yacurier.ru/v1",
        // baseUrl: "//remote.api.idelivery.local/v1",
        links: {
            geoByName: "/wf/geo/search-name",
            geoByGps: "/wf/geo/search-gps",
            geoByIp: "/wf/geo/search-ip",
            order: "/wf/order",
        },
        getRequest(url, params = {}){
            return axios
                .get(this.baseUrl + url, {
                    params: params
                })
                .then((repsonse) => {
                    if (repsonse.status >= 200 && repsonse.status < 300){
                        return repsonse.data;
                    }else{
                        throw (typeof response.data.message != "undefined" ? response.data.message : "Неизвестная ошибка");
                    }
                });
        },
        postRequest(url, params = {}){
            return axios
                .post(this.baseUrl + url, params)
                .then((repsonse) => {
                    if (repsonse.status >= 200 && repsonse.status < 300){

                        return repsonse.data;
                    }else{
                        throw (response.data.message ? response.data.message : "Неизвестная ошибка");
                    }
                });
        },
        getAddressByIP(){
            return this
                .getRequest(this.links.geoByIp);
        },
        getAddressByGps(lat, lng){
            return this
                .getRequest(this.links.geoByGps, {
                    lat: lat,
                    lng: lng
                });
        },
        getAddressByName(search){
            return this
                .getRequest(this.links.geoByName, {
                    query: search
                });
        },
        createOrder(data = {}, code = null){
            return this
                    .postRequest(this.links.order, data);
        }
    };

    const store = {
        full: false,
        stateFull: function(state = false){
            this.full = state;
            if (state){
                document.body.style.overflow = "hidden";
            }else{
                document.body.style.overflow = "auto";
            }
        },
        debug: false,
        modalState: false,
        message: null,
        messageType: 'error',
        order: {
            addresses: [
            ],
            cost: 0,
            place: 1,
            weight: 0,
            length: 0,
            width: 0,
            height: 0,
            preSummary: 0,
            useProperty: false,
            client: null,
            start: null,

        },
        indexAddress: null,
        needSms: false,
        getNulledAddress(){
            const address =  {
                address: null,
                house: null,
                entrance: 0,
                flat: 0,
                lat: null,
                lng: null,
                member: null,
                phone: null,
                time: null,
                comment: null,
                cost: 0
            };
            return Object.assign({}, address);
        },
        addAddress(){
            if (this.debug) {
                console.log("addAddress вызвано");
            }
            this.order.addresses.push(this.getNulledAddress());
        },
        deleteAddress(index){
            if (this.debug) {
                console.log("deleteAddress вызвано с ", index);
            }
            if (this.order.addresses.length > 2) {
                this.order.addresses.splice(index, 1);
            }else{
                this.order.addresses[index] = this.getNulledAddress();
            }
        },
        showModal(index){
            this.indexAddress = index;
            this.modalState = true;
        },
        hideModal(){
            this.indexAddress = null;
            this.modalState = false;
        },
        init(){
            this.indexAddress = null;
            this.order.addresses = [];
            this.order.cost =  0;
            this.order.place =  1;
            this.order.weight =  0;
            this.order.length =  0;
            this.order.width =  0;
            this.order.height =  0;
            this.order.preSummary =  0;
            this.order.useProperty =  false;
            this.order.client =  null;
            this.order.start =  null;
            this.addAddress();
            this.addAddress();
        },
        createOrder(code = null){
            const order = {
                code: code,
                client: this.order.client,
                summary: this.order.cost,
                start: !this.order.start ? null : [
                    [
                        (this.order.start.getDate() < 10 ? "0" : "") + this.order.start.getDate(),
                        (this.order.start.getMonth() < 9 ? "0" : "") + (this.order.start.getMonth()+1),
                        this.order.start.getFullYear()
                    ].join('.'),
                    [
                        (this.order.start.getHours() < 10 ? "0" : "") + this.order.start.getHours(),
                        (this.order.start.getMinutes() < 10 ? "0" : "") + this.order.start.getMinutes()
                    ].join(':')
                ].join(' '),
                route: this.order.addresses.map((address) => {
                    return {
                        summary: 0,
                        comment: address.comment,
                        human: {
                            name: address.member,
                            phone: address.phone,
                            time: !address.time ? null : [
                                (address.time.getHours() < 10 ? "0" : "") + address.time.getHours(),
                                (address.time.getMinutes() < 10 ? "0" : "") + address.time.getMinutes()
                            ].join(':')
                        },
                        geo: {
                            lat: address.lat,
                            lng: address.lng,
                            flat: address.flat,
                            entrance: address.entrance
                        },
                        isset_cargo: false,
                        cargo: {}
                    };
                })
            };
            if (order.route.length){
                order.route[0].summary = this.order.preSummary;
                order.route[0].geo.isset_cargo = this.order.useProperty;
                if (this.order.useProperty){
                    order.route[0].cargo = {
                        count: this.order.place,
                        weight: this.order.weight,
                        length: this.order.length,
                        width: this.order.width,
                        height: this.order.height
                    };
                }

            }
            return Api.createOrder(order);
        },
        closeMessage(){
            this.message = null;
        },
        openMessage(message, type = 'error'){
            this.messageType = type;
            this.message = message;
        },
        openCode(){
            this.needSms = true;
        },
        closeCode(){
            this.needSms = false;
        }
    };
    store.init();

    export default {
        rules: {
            'no-console': 'on',
        },
        name: 'app',
        data(){
            return {
                store: store,
                Api: Api
            }
        },
        components: {
            SmallForm,
            FullForm,
        },
        mounted: () => {
            Api
                .getAddressByIP()
                .then((response) => {
                    if (typeof response.data.cost != "undefined"){
                        store.order.addresses[0].cost = response.data.cost;
                    }
                })
                .catch((error) => {
                    alert(error);
                })

        }
    }
</script>





<style lang="scss">
    #yacurier-form{
        font-family: 'Open Sans', sans-serif;
        margin: 40px 0;
        input[type*="te"],
        input[type="number"],
        input[type="time"],
        textarea{
            font-family: 'Open Sans', sans-serif;
        }
        button{
            border: 1px solid #C3C8D7;
            cursor: pointer;
            font-size: 14px;
        }
        .single-button{
            background: #FFD957;
            border: none;
            border-radius: 3px;
            color: #60605D;
            cursor: pointer;
            font-size: 18px;
            margin: 20px 0 10px;
            padding: 10px 0 12px;
            outline: none;
            transition: all .125s ease-in;
            width: 100%;
            &:hover{
                background: #ffd043;
            }
        }
        .mx-calendar-content{
            .cell{
                &.actived{
                    background-color: #FFD957;
                    color: #60605D;
                }
            }
        }
        .mx-datepicker{
            display: inherit;
            width: auto;
            .mx-input-wrapper{
                width: 100%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue